module.exports = __webpack_public_path__ + "static/media/file.a47c091c.svg";